<template>
    <kgr-form-scaffold
        :pending="pending"
        :pending-delete="pendingRemove"
        with-primary-buttons
        with-delete-button
        edit-mode
        @backBtnClicked="redirectToOverview"
        @primaryBtnClicked="updateDog"
        @deleteBtnClicked="removeDog"
    >
        <kgr-dog-data-provider
            :dog-id="dogId"
            :callback="onDogLoaded"
        >
            <div class="animated fadeIn">
                <kgr-dog-form
                    v-if="dog !== null"
                    :new-dog="dog"
                    :error="error"
                    :club-id="clubId"
                    edit-mode
                    @update="update"
                />
            </div>
        </kgr-dog-data-provider>
    </kgr-form-scaffold>
</template>

<script>
import DogForm from '../../components/dog/DogForm.vue';
import DogRepository from '../../js/repository/DogRepository.js';
import Error from '../../js/model/Error.js';
import KgrDogDataProvider from '../../components/data-provider/DogDataProvider.vue';
import KgrFormScaffold from '../../components/common/form/FormScaffold.vue';

export default {
    components: {
        'kgr-form-scaffold': KgrFormScaffold,
        'kgr-dog-data-provider': KgrDogDataProvider,
        'kgr-dog-form': DogForm,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true,
        },
        dogId: {
            type: String,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            pendingRemove: false,
            error: new Error(),
            dog: null,
        };
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        onDogLoaded(dog) {
            this.dog = dog;
        },
        update(dog) {
            this.dog = dog;
        },
        updateDog() {
            DogRepository.update(this.dog)
                .then(() => {
                    this.error = new Error();
                    this.$notify.success('saveChanges.success');
                    this.pending = false;
                })
                .catch((error) => {
                    this.handleError(error);
                    this.pending = false;
                });
        },
        removeDog() {
            showConfirm(this.$t('confirm'), this.$t('club.dog.delete.confirm', { dog: this.dog.name }), () => {
                this.pendingRemove = true;
                DogRepository.remove(this.dog.id)
                    .then(() => {
                        this.error = new Error();
                        this.$notify.success('Hund erfolgreich gelöscht', {}, { saveInSession: true });
                        this.redirectToOverview();
                    })
                    .catch((error) => {
                        this.handleError(error);
                        this.pendingRemove = false;
                    });
            }, 'Ok');
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
